import { Box, Button, Divider, Link as MuiLink, Stack, Typography } from "@mui/material"
import { Fragment, useEffect, useState } from "react"
import { Link, useLocation } from "react-router-dom"
import { RoutePaths } from "../routes";
import { useNews } from "../hooks/useNews"; 



const NewsPage = () => {
    const { news: allNews, loading, error } = useNews();
    const location = useLocation()
    const [hoverIndex, setHoverIndex] = useState(null)
    const [viewCount, setViewCount] = useState(location.state?.viewCount ?? 3)
    const step = 3;

    // Сортировка новостей по дате (новые сверху)
    const sortedNews = [...allNews].sort((a, b) => {
        const dateA = new Date(a.date || a.publishedAt);
        const dateB = new Date(b.date || b.publishedAt);
        return dateB - dateA; // Обратная сортировка
    });

    const viewNews = sortedNews
        .filter((_, i) => i < viewCount)

    const formatDate = (date) => {
        return new Date(date).toLocaleDateString('ru-RU', {
            day: 'numeric',
            month: 'long',
            year: 'numeric'
          })
    }
    useEffect(() => {
        if (location.state?.scrollY !== undefined) {
            window.scrollTo(0, location.state.scrollY);
        }
    }, [location]);

    if (loading) return <Typography variant="h3">Загрузка новостей...</Typography>;
    if (error) return <Typography color="error">{error}</Typography>;

    return (
        <>
            <Typography variant="h1">НОВОСТИ</Typography>
            <Stack spacing={5}>
                {viewNews.map((item, index) => (
                    <Fragment key={item.id}>
                        <Stack
                            direction={{
                                xs: 'column-reverse',
                                sm: 'row',
                            }}
                            spacing={{
                                xs: 1,
                                sm: 3,
                                lg: 5,
                            }}
                            onMouseEnter={() => setHoverIndex(item.id)}
                            onMouseLeave={() => setHoverIndex(null)}
                        >
                            <Stack spacing={2} style={{flexGrow: 1}}>
                                <MuiLink component={Link}
                                    to={RoutePaths.CURRENT_NEWS.replace(":id", item.id)}
                                    state={{ 
                                        scrollY: window.scrollY,
                                        viewCount
                                     }}
                                    variant="h3"
                                    underline='none'
                                    color={hoverIndex === item.id ? 'red.400' : 'blue.400'}
                                >{item.title}</MuiLink>
                                <Typography variant="body4" sx={{ opacity: 0.6 }}>{item.description}</Typography>
                                <Typography variant="body4" color={hoverIndex === item.id ? 'red.400' : 'blue.400'} >{formatDate(item.date)}</Typography>
                            </Stack>

                            {item.img &&
                                <Box sx={{
                                    height: {
                                        lg: '210px',
                                        md: '200px',
                                        sm: '160px',
                                        xs: '150px',
                                    }
                                }}>
                                    <img src={item.img} alt={item.title} style={{ height: '100%' }} />
                                </Box>
                            }
                        </Stack>

                        {(index < viewCount - 1) && <Divider />}

                    </Fragment>
                ))}

                { allNews.length > viewCount &&
                    <Box>
                        <Button 
                            variant="contained" 
                            onClick={() => setViewCount(prev => prev + step)}
                        >
                            ЗАГРУЗИТЬ ЕЩЁ
                        </Button>
                    </Box>
                }
            </Stack>
        </>
    )
}

export default NewsPage;